import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

declare let alertify: any;

@Injectable({
  providedIn: "root",
})
export class AlertifyService {
  isLoading$: BehaviorSubject<boolean>; // Subscribe this observable to determin if the page is loading to lock it.
  public loading = false;

  constructor() {
    alertify.set("notifier", "position", "top-right");
    alertify.set("notifier", "delay", 5);
    this.isLoading$ = new BehaviorSubject<boolean>(false);
  }

  confirm(message: string, okCallback: () => any) {
    alertify
      .confirm()
      .setting({
        label: "<em>STP AuditHub</em>",
        message: message,
        onok: function () {
          alertify.success("Ok");
        },
      })
      .show();
  }

  confirmOkCancel(
    title: string,
    message: string,
    okCallback: () => any,
    cancelCallback: () => any,
    okLabel?: string,
  ) {
    const dialog = alertify.confirm(
      title,
      message,
      () => {
        okCallback();
      },
      () => {
        cancelCallback();
      },
    );
    // Only this dialog instance's label changes - other confirmOkCancel() callers keep
    // alertify's default "OK"/"Cancel" since okLabel is optional.
    if (okLabel) {
      dialog.set({ labels: { ok: okLabel } });
    }
  }

  showLoadingAnimation(showFlag: boolean) {
    this.loading = showFlag;
    this.isLoading$.next(showFlag);
  }

  confirmOk(message: string) {
    alertify
      .alert()
      .setting({
        label: "Ok",
        message: message,
      })
      .setHeader("<b>STP AuditHub</b>")
      .show();
  }

  addSuccess(message: string) {
    this.success(`Add ${message} successfully`);
  }

  editSuccess(message: string) {
    this.success(`Edit ${message} successfully`);
  }

  deleteSuccess(message: string) {
    this.success(`Delete ${message} successfully`);
  }

  private buildNotifyHtml(icon: string, message: string): string {
    return `<span style="display:flex;flex-direction:column;gap:6px;">
        <span style="display:flex;align-items:center;gap:6px;">
          <i class="material-icons" style="font-size:18px;animation:error-flash 1.2s ease-in-out 1">${icon}</i>
          <span style="flex:1">${message}</span>
          <button onclick="this.closest('.ajs-message').remove()" style="background:none;border:none;cursor:pointer;color:inherit;opacity:0.7;padding:0;margin-left:4px;font-size:16px;line-height:1;" title="Close">✕</button>
        </span>
        <span style="height:3px;background:rgba(255,255,255,0.3);border-radius:2px;overflow:hidden;">
          <span style="display:block;height:100%;width:100%;background:rgba(255,255,255,0.9);animation:progress-shrink 5s linear forwards;"></span>
        </span>
      </span>`;
  }

  success(message: string) {
    alertify.success(this.buildNotifyHtml("check_circle", message));
  }

  error(message: string) {
    try {
      if (message === "Internal server error") {
        console.debug("internal error: " + message);
        message = "The system is busy. Please try again later.";
      }
      alertify.error(this.buildNotifyHtml("error", message));
    } catch (Error) {
      console.error(Error.message);
    }
  }

  warning(message: string) {
    alertify.notify(this.buildNotifyHtml("warning", message), "warning", 5, null);
  }

  message(message: string) {
    alertify.message(message);
  }
}
